<template>
	<div class="page">
		<top-header></top-header>
		<div class="cont-box">
		<b-container fluid style="margin-top: 5%;">
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6">
					<h3 class="text-white">Manage Users</h3>
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
					<b-button variant="dark" pill class="mr-2" @click="showAddModal()" v-if="$root.chkperm('page_users','add')">Add User</b-button>
					<b-button variant="dark" pill class="mr-2" @click="redirectUrl('/user-roles')" v-if="$root.chkperm('page_roles','enabled')">Manage Roles</b-button>
					<b-button variant="dark" pill  @click="downloadcsv()">Export</b-button>
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box">
						<b-row class="mt-4 px-3">
							<b-col lg="6">
								<span class="mr-2">Show</span>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
								</b-form-select>
								<span class="ml-2">entries</span>
							</b-col>
							<b-col lg="4" offset-md="2">
								<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
									<b-input-group size="sm">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
									<template #cell(id)="records">
										{{ records.index+1}}
									</template>
									<template v-slot:cell(status)="row">
										<b-badge pill variant="danger" v-if="row.value == 0">INACTIVE</b-badge>
										<b-badge pill variant="success" v-else>ACTIVE</b-badge>
									</template>
									<template v-slot:cell(actions)="row">
										<b-button pill variant="primary" v-if="row.item.role!=1 && $root.chkperm('page_users','edit')" class="mr-1" @click="showUpdateModal(row.item, row.index, $event.target)" size="sm">EDIT</b-button>
										<b-button pill variant="danger" v-if="row.item.role!=1 && $root.chkperm('page_users','delete')" class="mr-1" @click="showDeleteModal(row.item)" size="sm">DELETE</b-button>
									</template>
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="6">
								<span class="mr-2">Showing 1 to 5 of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>

			
			<b-modal id="my-modal" :title="(selectedItem.id > 0)?'Edit User':'Add User'" size="lg" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
				<form ref="form" @submit.stop.prevent="handleSubmit">
					<b-container fluid>
						<b-row class="mb-3">
							<b-col>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right font-sm">Username :</b-col>
									<b-col cols="8"><b-form-input v-model="selectedItem.username" size="sm" required></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right font-sm">Email :</b-col>
									<b-col cols="8"><b-form-input v-model="selectedItem.email" size="sm" required></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right font-sm">Phone :</b-col>
									<b-col cols="8"><b-form-input v-model="selectedItem.mobile_no" size="sm" required></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right font-sm">Role :</b-col>
									<b-col cols="8"><b-form-select v-model="selectedItem.role" size="sm" :options="user_roles" label-field="title" value-field="id" required></b-form-select></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right font-sm">Password :</b-col>
									<b-col cols="8"><b-form-input v-model="selectedItem.password" size="sm" required></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right font-sm">Secure Code :</b-col>
									<b-col cols="8"><b-form-input v-model="selectedItem.secure_code" size="sm" required></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right font-sm">Status :</b-col>
									<b-col cols="8"><b-form-select v-model="selectedItem.status" :options="$root.status_options" size="sm" required></b-form-select></b-col>
								</b-row>
							</b-col>
							<b-col>

								<b-alert variant="warning" class="alert-heading" show>Extra Permissions</b-alert>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right font-sm">Multi Login :</b-col>
									<b-col cols="8"><b-form-select v-model="selectedItem.permissions.multi_login" size="sm" required>
											<b-form-select-option value="0">No</b-form-select-option>
											<b-form-select-option value="1">Yes</b-form-select-option>
										</b-form-select>
									</b-col>
								</b-row>
								<!-- <b-row class="mb-3">
									<b-col cols="4" class="text-right font-sm">Logo (left) :</b-col>
									<b-col cols="8"><b-form-input v-model="selectedItem.permissions.logo_left" size="sm" required></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right font-sm">Logo (center) :</b-col>
									<b-col cols="8"><b-form-input v-model="selectedItem.permissions.logo_center" size="sm" required></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right font-sm">Logo (right) :</b-col>
									<b-col cols="8"><b-form-input v-model="selectedItem.permissions.logo_right" size="sm" required></b-form-input></b-col>
								</b-row> 
								<b-row class="mb-3">
									<b-col cols="4" class="text-right font-sm">MAP :</b-col>
									<b-col cols="8"><b-form-input v-model="selectedItem.permissions.map" size="sm" required></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right font-sm">Dashboard :</b-col>
									<b-col cols="8"><b-form-input v-model="selectedItem.permissions.dashboard_link" size="sm" required></b-form-input></b-col>
								</b-row>-->
								<b-row class="mb-3">
									<b-col cols="4" class="text-right font-sm">State Perm. {{selectedItem.permissions.state_perm}} :</b-col>
									<b-col cols="8">
										<!-- :options="$root.state_options" -->
										<b-form-select v-model="selectedItem.permissions.state_perm"  @change="selectedItem.permissions.ulb_perm=''; updateLink()" size="sm" required>
											<b-form-select-option value="">Full Access</b-form-select-option>
										</b-form-select>
									</b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="4" class="text-right font-sm">ULB Perm. :</b-col>
									<b-col cols="8">
										<b-form-select v-model="selectedItem.permissions.ulb_perm" @change="updateLink()" size="sm">
											<b-form-select-option v-for="item in filterULB(zones)" v-bind:key="item.id" :value="item.value">{{item.title}}</b-form-select-option>
											<b-form-select-option value="">Full Access</b-form-select-option>
										</b-form-select>
									</b-col>
								</b-row>
							</b-col>
						</b-row>
					</b-container>
				</form>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
				</template>
			</b-modal>
		
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
	</div>
	</div>
	
</template>
<script>
import Header from "@/components/Header.vue";
export default {
	name: 'Devices',
	components: {
		"top-header": Header
	},
	mounted(){
		var self = this;
		Object.assign(self.selectedItem, self.emptyItem);
		this.initload();
	},
	data() {
		var self = this;
		return{
			loading: true, 
			email: '',
			password: '',
			recordUrl: self.$session.get('apiurl')+'kmrlapi/users',
			insertUrl: self.$session.get('apiurl')+'kmrlapi/user-insert',
			updateUrl: self.$session.get('apiurl')+'kmrlapi/user-update',
			deleteUrl: self.$session.get('apiurl')+'kmrlapi/user-delete',
			zones: [],
			records: [],
			statusOptions: [{ value: 0, text: 'Disabled' },{ value: 1, text: 'Enabled' }],
			user_roles: [],
			fields: [
				{ key: 'id', label: 'ID'},
				{ key: 'username', label: 'Username'},
				{ key: 'email', label: 'Email'},
				{ key: 'role', label: 'Role', 
					formatter: (value, key, item) => {
						var val;
						self.user_roles.forEach(function(field){
							if(item.role == field.id){
								val = field.text;
							}
						});
						return val;
					},
				},
				{ key: 'secure_code', label: 'Secure Code' },
				{ key: 'status', label: 'Status' },
				{ key: 'actions', label: 'Actions', 'extra': 1 }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {
				permissions: {multi_login: 0, dashboard_link:'', state_perm:'', district_perm:'', ulb_perm:''},
			},
			emptyItem: {
				id: 0,
				username: '',
				email: '',
				mobile_no:'',
				role: 0,
				secure_code: '',
				permissions: {multi_login: 0, dashboard_link:'', state_perm:'', district_perm:'', ulb_perm:''},
				status: 0
			}
		};
	},
	methods: {
		updateLink: function(){
			var self = this;
			if(self.selectedItem.permissions.ulb_perm != ''){
				self.selectedItem.permissions.dashboard_link = '/devices/'+self.selectedItem.permissions.ulb_perm;
			}else{
				if(self.selectedItem.permissions.state_perm != ''){
					self.selectedItem.permissions.dashboard_link = '/state-dashboard/'+self.selectedItem.permissions.state_perm;
				}else{
					self.selectedItem.permissions.dashboard_link = '';
				}
			}
		},
		filterZone: function (items) {
			var self = this;
			return items.filter(function (item) {
				
				if(item.parent ==0){
					return item.state  == self.selectedItem.permissions.state_perm;
				}
			})
		},
		filterULB: function (items) {
			var self = this;
			
			return items.filter(function (item) {
				return item.state == self.selectedItem.permissions.state_perm;
			})
		},
		redirectUrl(url){
			this.$router.push(url);
		},
		showAddModal(){
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.$root.$emit('bv::show::modal', 'my-modal');
		},
		showUpdateModal(item, index, button) {
			this.selectedItem = Object.assign({}, item);
			this.$root.$emit('bv::show::modal', 'my-modal', button)
		},
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete User.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						deleteid: item.id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		modalSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			var submitUrl = "";
			if(self.selectedItem.id == 0){
				submitUrl = self.insertUrl;
			}else{
				submitUrl = self.updateUrl;
			}


			self.axios.post(submitUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.selectedItem
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('my-modal');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		
		

		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					//var filteredarr = self.filtercategory(response.data.result);

					self.records = response.data.result.users;
					self.records.forEach(function(field){
						field.permissions = JSON.parse(field.permissions);
					});
					self.user_roles = response.data.result.roles;

					self.zones = response.data.result.zones;

					self.loading = false;
					self.totalRows = self.records.length;
					
				}
				else{
					self.$root.forceLogout(response.data.message);
				}
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		downloadcsv(){
			var self = this;
			var header = new Array()
			self.fields.forEach(function(item){
				if(!item.extra){
					header.push(item.label);
				}
			});
			
			//var d = table.rows().data();
			var finalarr = new Array();
			finalarr.push(header);
			self.records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
			
			let csvContent = "data:text/csv;charset=utf-8," 
			+ finalarr.map(e => e.join(",")).join("\n");

			var encodedUri = encodeURI(csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "zone_report.csv");
			document.body.appendChild(link); // Required for FF

			link.click();
		}
	}
}
</script>
<style>
html{
	min-height: 100%;
}
/* body{
	background-color: '#FFF' !important;
	background-image: none !important;
} */
body{
	background-image: url(../assets/home-banner.png) !important;
	background-repeat: no-repeat;
	background-size: cover;
	/* background-position: center center; */
	background-position: bottom;
   
}

.table{
	font-size: small;
}
.table .btn{
	font-size: 12px;
}
.table td, .table th{
	vertical-align: middle;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
</style>